<ion-content class="modal-content">
  <div class="modal-container w-full">
    <h3 class="title">{{ "confirm-vr-clone-modal.title" | translate }}</h3>
    <p class="message">{{ "confirm-vr-clone-modal.description" | translate }}</p>
    <p class="label">{{ "confirm-vr-clone-modal.detail-label" | translate }}</p>

    <div class="detail-container">
      <div class="ticket-detail-row">
        <span class="label-detail">{{ "confirm-vr-clone-modal.assignee-label" | translate }}</span>
        <span class="value-detail">{{ assigneeLabel }}</span>
      </div>
      <div class="ticket-detail-row">
        <span class="label-detail">{{ "confirm-vr-clone-modal.quantity-label" | translate }}</span>
        <span class="value-detail">1</span>
      </div>
      <div class="ticket-detail-row">
        <span class="label-detail">{{ "confirm-vr-clone-modal.status-label" | translate }}</span>
        <span class="value-detail unpaid">{{ "confirm-vr-clone-modal.unpaid-badge" | translate }}</span>
      </div>
      <div class="ticket-detail-row">
        <span class="label-detail">{{ "confirm-vr-clone-modal.amount-label" | translate }}</span>
        <span class="value-detail">{{ formattedAmount }}</span>
      </div>
    </div>

    <div class="button-container">
      <ion-button
        expand="block"
        class="btn-cancel"
        color="medium"
        (click)="closeModal()"
      >{{ "confirm-vr-clone-modal.cancel" | translate }}</ion-button>

      <ion-button
        expand="block"
        class="btn-config btn-expand"
        (click)="cloneTicket()"
        [disabled]="isCloning"
      >
        {{ isCloning ? ("confirm-vr-clone-modal.loading" | translate) : ("confirm-vr-clone-modal.clone" | translate) }}
      </ion-button>
    </div>
  </div>
</ion-content>
